export default "__VITE_ASSET__fd429187__"